/*
 *  Project: dux - file input
 *  Description: style file input control
 *  Author: bwin
 */

require( 'vendor/jquery-watch' );

(function ( $, window, document, undefined ){
    'use strict';

    // Create the defaults
    var pluginName = 'dv_fileinput',
        objData,
        defaults = {
            btnText: '',
            btnType: 'default',
            size: '',
            icon: '',
            disabled: false,
            placeholder: '',
            dropzone: false,
            dropzoneCaption: 'Dropzone',
            dropzoneMultipleDisplay: '{dv-file-count} files selected'
        };

    // The actual plugin constructor
    function Plugin( element, options ){
        this.element = element;
        this.$element = $( this.element );
        this.$elementID = this.$element.attr( 'id' );

        // future instances of the plugin
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend( Plugin.prototype, {
        init: function (){

            var $nInputGroup = $( '<div class="input-group" id="dv-fileInput-group-' + this.$elementID + '"/>' ),
                $nInput = this.$element.attr( 'readonly' ) ?
                    $( '<input type="text" class="form-control origin-has-readonly" id="dv-fileInput-' + this.$elementID + '" readonly/>' ) :
                    $( '<input type="text" class="form-control" id="dv-fileInput-' + this.$elementID + '" readonly/>' ),
                $nBtnGroup = $( '<span class="input-group-btn"><button type="button" id="dv-file-btnBrowse-' + this.$elementID + '" class="btn btn-default"></button></span>' ),
                $oForm = this.$element.closest( 'form' ),
                $nDropZone,
                $nBtnBrowse,
                advUpload = this._isAdvancedUpload(),
                self = this;

            // Add new input group with input and button
            $nInputGroup.insertAfter( this.$element ).append( $nInput, $nBtnGroup );

            this._hideOrigin();
            this.setSize( this.settings.size );
            this.setBtnText( this.settings.btnText );
            this.setBtnType( this.settings.btnType );
            this.setIcon( this.settings.icon );
            this.setPlaceholder( this.settings.placeholder );
            this.disableFileInput( this.settings.disabled );
            this._addDropZone( advUpload, this.settings.dropzone );

            this.$element.unwatch( '_dataDisabled' );

            this.$element.watch( {
                properties: 'attr_data-disabled',
                id: '_dataDisabled',
                watchChildren: false,
                callback: function ( data, i ){
                    self.update( {
                        disabled: data.vals[ i ]
                    } )
                }
            } );

            $nBtnBrowse = $( '#dv-file-btnBrowse-' + this.$elementID );

            // Prevent focus
            this.$element.attr( 'tabIndex', -1 );
            $nBtnGroup.attr( 'tabIndex', -1 );
            $nBtnBrowse.attr( 'tabIndex', -1 );

            // Default browser control change
            this.$element.on( 'change', function (){
                var fileList = this.files,
                    fileListLen = fileList.length;

                self._addBtnReset( fileListLen );
                self._showFileName( fileList );

            } );

            // Listen on keyboard events
            $nInput.on( 'keydown', function ( e ){

                var charCode = e.keyCode || e.which;

                if ( charCode === 13 ) { // Enter
                    e.preventDefault();
                    self._openFileDialog();
                } else if ( charCode === 8 || charCode === 46 ) { // Backspace & Del
                    self._reset();
                } else if ( charCode === 9 ) { // TAB

                } else {
                    return false;
                }
            } );

            // Blur origin on blurring custom input
            $nInput.on( 'blur', function (){
                self.$element.blur();
            } );

            // Force default browser control behavior with btn click
            $nBtnBrowse.on( 'click', function (){
                self._openFileDialog();
            } );

            // Event handler for dropzone
            $nDropZone = $( '#dv-file-dropZone-' + this.$elementID );

            // Drag & drop listener for dropzone
            $nDropZone
                .on( 'drag dragstart dragend dragover dragenter dragleave drop', function ( e ){
                    e.preventDefault();
                    e.stopPropagation();
                } )
                .on( 'dragover dragenter', function ( e ){
                    e.originalEvent.dataTransfer.dropEffect = 'none';

                    if ( self.settings.dropzone === true && self.settings.disabled === false ) {
                        e.originalEvent.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
                        $( this ).addClass( 'is-dragover' );
                    }
                } )
                .on( 'dragleave dragend drop', function (){
                    $( this ).removeClass( 'is-dragover' );
                } )
                .on( 'drop', function ( e ){

                    var files = e.originalEvent.dataTransfer.files,
                        filesLen = files.length,
                        $this = $( this );

                    if ( !self._isMultiple( self.$element ) && filesLen > 1 ) {

                        $this
                            .addClass( 'has-error' )
                            .css( 'cursor', 'not-allowed', setTimeout( function (){
                                $this.removeAttr( 'style' ).removeClass( 'has-error' );
                            }, 1000 ) );

                    } else {

                        // Create string data from
                        // dropped file names
                        var $fileArr = $.makeArray( files );

                        var $tooltipData = $fileArr.map( function ( file ){
                            return file.name;
                        } ).join( ', ' );

                        // Change appearance of dropzone
                        // after dropping data on it
                        var $nDropReset = $( '<span/>' )
                            .attr( 'id', 'dv-file-dropReset-' + self.$elementID )
                            .css( 'cursor', 'pointer' )
                            .html( ' <i class="dv dv-close"></i>' );

                        $this
                            .addClass( 'has-data' )
                            .attr( 'title', $tooltipData )
                            .html( '<div class="badge">' + self._setTextAfterDrop( files ) + '</div>' )
                            .children( '.badge' )
                            .append( $nDropReset );

                        // Write object for form data
                        if ( files ) {
                            // Create editable object for form data
                            objData = {};

                            $.each( files, function ( i, file ){
                                objData[ self.$elementID + '-' + i ] = file;
                            } );
                        }

                        // Reset dropzone
                        $nDropReset.on( 'click', function (){
                            self._reset();
                        } );
                    }
                } );

            // Prevent drop events on document
            // to avoid files were open in browser
            $( document ).on( 'dragenter dragover drop', function ( e ){
                e.stopPropagation();
                e.preventDefault();
            } );

            // Add all files (objData) to form data
            // and send it to server

            if ( $oForm.attr( 'method' ) && $oForm.attr( 'action' ) ) {

                $oForm.on( 'submit', function ( e ){

                    e.preventDefault();

                    // Get current formdata of parent form
                    var formData = new FormData( $oForm.get( 0 ) );

                    // Append file to exisiting form data
                    if ( objData ) {

                        $.each( objData, function ( i, file ){
                            formData.append( self.$elementID, file );
                        } );

                    } else {

                        var fileList = self.$element[ 0 ].files;

                        $.each( fileList, function ( i, file ){
                            formData.append( self.$elementID, file );
                        } );
                    }

                    // Do the ajax server communication
                    $.ajax( {
                        url: $oForm.attr( 'action' ),
                        type: $oForm.attr( 'method' ),
                        data: formData,
                        dataType: 'json',
                        cache: false,
                        crossDomain: true,
                        contentType: false,
                        processData: false,
                        complete: function (){
                            if ( self.settings.dropzone ) {
                                var $dropReset = $( '#dv-file-dropReset-' + self.$elementID );
                                $dropReset.trigger( 'click' );
                            } else {
                                var $nInput = $( '#dv-fileInput-' + self.$elementID );
                                self._reset();
                                $nInput.blur();
                            }
                        },
                        success: function ( data ){
                            console.log( data.success ? 'success' : data.error );
                        }
                    } );
                } );
            }
        },
        _isAdvancedUpload: function (){
            var div = document.createElement( 'div' );
            return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
        },
        _addDropZone: function ( upload, dropzone ){
            if ( upload && dropzone ) {

                var $nDdropCaption = $( '<span/>' )
                    .attr( 'id', 'dv-file-dropCaption-' + this.$elementID )
                    .text( this.settings.dropzoneCaption );

                var $nDropZone = $( '<div/>' )
                    .addClass( 'dv-file-dropzone' )
                    .attr( 'id', 'dv-file-dropZone-' + this.$elementID )
                    .prepend( $nDdropCaption );

                var $nInputGroup = $( '#dv-fileInput-group-' + this.$elementID );

                // Replace the ordinary file input
                // with the dropzone
                $nInputGroup.replaceWith( $nDropZone );
            }
        },
        _isMultiple: function ( elm ){
            var $elm = $( elm );
            return $elm.prop( 'multiple' );
        },
        _setTextAfterDrop: function ( files ){
            var filesLen = files.length;

            if ( files && filesLen > 1 ) {
                return this.$element.attr( 'data-dropzone-multiple-display' ) ?
                    this.$element.attr( 'data-dropzone-multiple-display' ).replace( '{dv-file-count}', filesLen ) :
                    this.settings.dropzoneMultipleDisplay.replace( '{dv-file-count}', filesLen );
            } else {
                return files[ 0 ].name;
            }
        },
        _openFileDialog: function (){
            this.$element.focus().click();
        },
        _hideOrigin: function (){
            // Hide by shifting to the left so we
            // can still trigger events
            this.$element.css( {
                position: 'absolute',
                left: '-9999px'
            } );
        },
        _reset: function (){

            // On some browsers the files value is read-only
            // with this trick we remove the old input and add
            // a clean clone with all the original events attached
            this.$element.wrap( '<form>' ).closest( 'form' )[ 0 ].reset();
            this.$element.unwrap();

            //IE fix to reset
            this.$element.val( '' );

            this.$element.trigger( 'change' );

            // Remove reset button and clear input value
            $( '#dv-fileInput-' + this.$elementID ).val( '' );
            $( '#dv-file-btnReset-' + this.$elementID ).remove();

            // reset Dropdown
            this._resetDropdown();

        },
        _resetDropdown: function (){

            var $nDropZone = this.$element.next( '.dv-file-dropzone' );

            $nDropZone.children( '.badge' ).replaceWith( this.settings.dropzoneCaption );
            $nDropZone.removeClass( 'has-data' ).attr( 'title', '' );
            objData = undefined;
        },
        _showFileName: function ( files ){
            var $nInput = $( '#dv-fileInput-' + this.$elementID ),
                fileName = [];

            $.each( files, function ( key, value ){
                fileName.push( value.name );
            } );

            var strFiles = fileName.join( ', ' );

            $nInput.val( strFiles )
                .attr( 'title', strFiles ) // Show filename in title tootlip
                .focus(); // Regain focus;
        },
        _addBtnReset: function ( fileLen ){
            // Add a reset button to clear files
            var $nBtnBrowse = $( '#dv-file-btnBrowse-' + this.$elementID ),
                $nBtnReset = $( '<button type="button" id="dv-file-btnReset-' + this.$elementID + '" class="btn btn-default"></button>' ),
                $nIconReset = $( '<i class="dv dv-close text-center"></i>' ),
                resetBtnWidth;

            $( '#dv-file-btnReset-' + this.$elementID ).remove();

            if ( fileLen > 0 ) {
                // Reset all elements on click
                $nBtnReset
                    .insertBefore( $nBtnBrowse )
                    .on( 'click', $.proxy( this._reset, this ) );
            }

            if ( fileLen == 1 ) {
                $nBtnReset.removeAttr( 'style' ).html( $nIconReset );

            } else if ( fileLen > 1 ) {
                // Add the amount of files to the btnText
                // if the file count ist higher than one.
                $nBtnReset.html( '<span class="badge">' + fileLen + '</span>' );

                // Determine current width of reset button
                // and set this as style attribute.
                // Otherwise it seems to jump on hover.
                resetBtnWidth = $nBtnReset.outerWidth( true );
                $nBtnReset.css( 'width', resetBtnWidth );

                $nBtnReset.on( {
                    // Show the reset icon
                    mouseenter: function (){
                        $( this ).html( $nIconReset );
                    },
                    // Show in the file count and
                    // hide the reset icon
                    mouseleave: function (){
                        $( this ).html( '<span class="badge">' + fileLen + '</span>' );
                    }
                } );
            }
        },
        disableFileInput: function ( stat ){

            // Disable all elements, if disabled was set to true
            var $nInput = $( '#dv-fileInput-' + this.$elementID ),
                $nBtnBrowse = $( '#dv-file-btnBrowse-' + this.$elementID ),
                $nBtnReset = $( '#dv-file-btnReset-' + this.$elementID ),
                $oLabel = this.$element.prev( 'label' );

            if ( stat === 'true' || stat === true ) {

                stat = true;
                $oLabel.on( 'click', function ( e ){
                    e.preventDefault();
                } );

                $oLabel.addClass( 'text-muted' );
            }

            if ( stat === 'false' || stat === false ) {

                stat = false;
                $oLabel.removeClass( 'text-muted' ).unbind( 'click' );
            }

            this.settings.disabled = stat;
            this.$element.data( 'disabled', stat );
            this.$element.prop( 'disabled', stat );
            $nInput.prop( 'disabled', stat );
            $nBtnBrowse.prop( 'disabled', stat );
            $nBtnReset.prop( 'disabled', stat );

        },
        setPlaceholder: function ( placeholder ){
            // Add placeholder to new input
            var $nInput = $( '#dv-fileInput-' + this.$elementID );
            this.settings.placeholder = placeholder;

            if ( placeholder ) {
                $nInput.attr( 'placeholder', placeholder );
            } else {
                $nInput.removeAttr( 'placeholder' );
            }
        },
        setIcon: function ( icon ){
            // Add icon to button if icon was set
            if ( icon ) {
                var $nBtnBrowse = $( '#dv-file-btnBrowse-' + this.$elementID );
                var $nIcon = $( '<i class="dv ' + icon + '">' );
                $nBtnBrowse.prepend( $nIcon );
            }
        },
        setSize: function ( size ){
            // Set size of input group
            var nFileGroup = $( '#dv-fileInput-group-' + this.$elementID );

            if ( size !== '' ) {
                this.settings.size = size;
                if ( size === 'lg' ) {
                    nFileGroup.addClass( 'input-group-lg' );
                } else if ( size === 'sm' ) {
                    nFileGroup.addClass( 'input-group-sm' );
                }
            }
        },
        setBtnText: function ( text ){
            // When no text and no icon has been set, show ... instead
            var $nBtnBrowse = $( '#dv-file-btnBrowse-' + this.$elementID );

            if ( !text && !this.settings.icon ) {
                this.settings.btnText = '...';
                $nBtnBrowse.html( '<span>...</span>' )
            }

            if ( text && !this.settings.icon ) {
                this.settings.btnText = text;
                $nBtnBrowse.html( '<span> ' + text + '</span>' )
            }

            if ( text && this.settings.icon ) {
                this.settings.btnText = text;
                $nBtnBrowse.html( '<span class="hidden-xs"> ' + text + '</span>' )
            }
        },
        setBtnType: function ( type ){

            var $nBtnBrowse = $( '#dv-file-btnBrowse-' + this.$elementID );
            this.settings.btnType = type;
            $nBtnBrowse.addClass( 'btn-' + type );
        },
        update: function ( options ){
            if ( typeof options == 'object' ) {
                var updated = $.extend( {}, this.settings, options );
                this.setSize( updated.size );
                this.setBtnText( updated.btnText );
                this.setBtnType( updated.btnType );
                this.setIcon( updated.icon );
                this.setPlaceholder( updated.placeholder );
                this.disableFileInput( updated.disabled );
            }
        },
        clear: function (){
            this._reset();
        },
        destroy: function (){
            this.$element.removeAttr( 'style' );
            this.settings.dropzone ? this.$element.next( '.dv-file-dropzone' ).remove() : this.$element.next( '.input-group' ).remove();
            this.$element.prop( 'disabled' ) && this.settings.disabled && this.$element.prop( 'disabled', false );
        }
    } );

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[ pluginName ] = function ( options ){

        var args = arguments;

        // Is the first parameter an object (options), or was omitted,
        // instantiate a new instance of the plugin.
        if ( options === undefined || typeof options === 'object' ) {
            return this.each( function (){
                if ( !$.data( this, 'plugin_' + pluginName ) ) {
                    $.data( this, 'plugin_' +
                        pluginName, new Plugin( this, options ) );
                }
            } );

            // If the first parameter is a string and it doesn't start
            // with an underscore or "contains" the `init`-function,
            // treat this as a call to a public method.
        } else if ( typeof options === 'string' && options[ 0 ] !== '_' && options !== 'init' ) {

            // Cache the method call
            // to make it possible
            // to return a value
            var returns;

            this.each( function (){
                var instance = $.data( this, 'plugin_' + pluginName );

                // Tests that there's already a plugin-instance
                // and checks that the requested public method exists
                if ( instance instanceof Plugin && typeof instance[ options ] === 'function' ) {

                    // Call the method of our plugin instance,
                    // and pass it the supplied arguments.
                    returns = instance[ options ].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                // Allow instances to be destroyed via the 'destroy' method
                if ( options === 'destroy' ) {
                    $.data( this, 'plugin_' + pluginName, null );
                }
            } );

            // If the earlier cached method
            // gives a value back return the value,
            // otherwise return this to preserve chainability.
            return returns !== undefined ? returns : this;
        }
    };

})( jQuery, window, document );

// Select elements with certain css-class
// data-attributes help to style selection
(function ( $, window, document, undefined ){
    $( function (){

        $( '.dv-file-input' ).each( function (){

            var $this = $( this ), options = {

                'btnText': $this.attr( 'data-btn-text' ),
                'btnType': $this.attr( 'data-btn-type' ),
                'size': $this.attr( 'data-size' ),
                'icon': $this.attr( 'data-icon' ),
                'disabled': $this.attr( 'data-disabled' ) === 'true' ? true : false,
                'placeholder': $this.attr( 'data-placeholder' ),
                'dropzone': $this.attr( 'data-dropzone' ) === 'true' ? true : false,
                "dropzoneCaption": $this.attr( 'data-dropzone-caption' ),
                'dropzoneMultipleDisplay': $this.attr( 'data-dropzone-multiple-display' )
            };

            $this.dv_fileinput( options );
        } );
    } );
})( jQuery, window, document );